import {
    
    RESET_MESSAGE,
    GET_DELIVERY_ORDER_LIST_SUCCESS,
    GET_DELIVERY_ORDER_LIST_FAILURE,
    GET_DELIVERY_ORDER_LIST_PROGRESS,
    ADD_DELIVERY_ORDER_PROGRESS,
    ADD_DELIVERY_ORDER_SUCCESS,
    ADD_DELIVERY_ORDER_FAILURE,
    EDIT_DELETE_DELIVERY_ORDER_PROGRESS,
    EDIT_DELETE_DELIVERY_ORDER_SUCCESS,
    EDIT_DELETE_DELIVERY_ORDER_FAILURE,

} from '../../types/actionTypes';

const initialState = {
    delivery_order: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const delivery_order_reducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_DELIVERY_ORDER_LIST_SUCCESS:
            return { ...state, delivery_order: action.delivery_order, loading: false };
        case GET_DELIVERY_ORDER_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_DELIVERY_ORDER_LIST_PROGRESS:
            return { ...state, loading: true, error: false };

        case ADD_DELIVERY_ORDER_PROGRESS:
            return { ...state, loading: true };
        case ADD_DELIVERY_ORDER_SUCCESS:
            return { ...state, delivery_order: [...state.delivery_order, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_DELIVERY_ORDER_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case EDIT_DELETE_DELIVERY_ORDER_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_DELIVERY_ORDER_SUCCESS:
            return {
                ...state,
                delivery_order: state.delivery_order.map((delivery_order) =>
                    delivery_order.id === action.payload.id ? action.payload : delivery_order
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_DELIVERY_ORDER_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case RESET_MESSAGE:
            return { ...state, message: null };

        default:
            return state
    }
}

export default delivery_order_reducer;